import React, { Fragment, useRef } from "react";
import { useState, useEffect } from "react";
import { useGlobalState } from "../Context/GlobalStateContext";
import MainTopFilters from "../App/MainTopFilters";
import { type } from "os";
import { json } from "d3";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import InputMask from "../App/InputMask";
import { getAccessSettings, removeNonNumeric } from "../Shared/Utility";
import DonutChart from "../Charts/DonutChart";

export default function ExceptionHistory() {
  const globalState = useGlobalState();

  const [showAnimation, setShowAnimation] = useState(false);
  const [showSummaryView, setShowSummaryView] = useState(true);

  const [programDashboardFilter, setProgramDashboardFilter] = useState({    
    ProgramID: globalState.TopFilterData.IBBProgramID,
    QuarterID: 0,//globalState.TopFilterData.QuarterID,
    PFIDealerID: 0,
    IBBScorecardID: 0,
    PFIGroupIDs: "1",
  });

  const [programList, setProgramList] = useState<any>([]);
  const [programData, setProgramData] = useState({}) as any;

  const [quarterList, setQuarterList] = useState<any>([]);

  const [dealerList, setDealerList] = useState<any>([]);

  const [importerList, setImporterList] = useState<any>([]);
  const [importerListBK, setImporterListBK] = useState<any>([]);
  const [groupList, setGroupList] = useState<any>([]);

  const [sectionList, setSectionList] = useState<any>([]);
  const [sectionListBK, setSectionListBK] = useState<any>([]);
  const [criteriaList, setCriteriaList] = useState<any>([]);
  const [inputData, setInputData] = useState<any>([]);

  const [totalData, setTotalData] = useState<any>([]);
  const [totalDataCriteria, setTotalDataCriteria] = useState<any>([]);
  const [totalDataRows, setTotalDataRows] = useState<any>([
    { Name: "Fails" },
    { Name: "Raised Exceptions" },
    { Name: "Approved Exceptions" },
  ]);

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") {
      IBBProgramID = Number(IBBProgramID);
      setProgramDashboardFilter((prevState: any) => ({
        ...prevState,
        ProgramID: IBBProgramID,
      }));
      IBBProgramGetProgramListForScorecard(IBBProgramID);
    } else IBBProgramGetProgramListForScorecard(0);

    IBBGroupGetCompleteGridData();
  }, []);

  useEffect(() => {
    if (programDashboardFilter.ProgramID > 0)
      IBBProgramCriteriaQuestionInputExceptionGetDataForExceptionHistory();
  }, [
    programDashboardFilter.ProgramID,
    programDashboardFilter.QuarterID,
    programDashboardFilter.PFIGroupIDs,
  ]);

  useEffect(() => {
    if (programDashboardFilter.ProgramID > 0) {
      if (showSummaryView)
        formatSectionAndCriteriaInputDataForSummaryScorecard();
      else formatSectionAndCriteriaInputDataForDetailsScorecard();
    }
  }, [inputData, sectionList]);

  useEffect(() => {
    if (programDashboardFilter.ProgramID > 0) formatSectionDataForScorecard();
  }, [criteriaList]);

  useEffect(() => {
    if (programDashboardFilter.ProgramID > 0) {
      formatSectionDataForScorecard();
    }
  }, [showSummaryView]);

  function IBBProgramGetProgramListForScorecard(IBBProgramID: number) {
    if (IBBProgramID == 0) IBBProgramID = programDashboardFilter.ProgramID;
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = IBBProgramID;
    object.numericquarter = programDashboardFilter.QuarterID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetProgramListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1 && result[0].length > 0) {
            setProgramList(result[0]);
            if (IBBProgramID == 0) {
              IBBProgramID = result[0][0].IBBProgramID;
              setProgramDashboardFilter((prevState: any) => ({
                ...prevState,
                ProgramID: IBBProgramID,
              }));
            }

            let filtered = result[0].filter(
              (item: any) => item.IBBProgramID == IBBProgramID
            );
            if (filtered.length > 0) {
              setProgramData(filtered[0]);
            }

            setQuarterList(result[2]);
            // if (programDashboardFilter.QuarterID == 0) {
            //   let QuarterID = result[2][0].PID;
            //   setProgramDashboardFilter((prevState: any) => ({
            //     ...prevState,
            //     QuarterID: QuarterID,
            //   }));
            // }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBGroupGetCompleteGridData() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.recordsperpage = 1000;
    object.sortexpressions = "Description";
    object.sortdirection = "D";
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL + "api/IBBGroup/IBBGroupGetCompleteGridData",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          let result = response.data.Data;
          if (result.length > 1) {
            if (result[1].length > 0) {
            }

            setGroupList(result[1]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramCriteriaQuestionInputExceptionGetDataForExceptionHistory() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = programDashboardFilter.ProgramID;
    object.numericquarter = programDashboardFilter.QuarterID;
    object.pfigroupids = programDashboardFilter.PFIGroupIDs;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgramCriteriaQuestionInputException/IBBProgramCriteriaQuestionInputExceptionGetDataForExceptionHistory",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 0) {
            setDealerList(result[0]);

            setImporterList(result[1]);
            setImporterListBK(result[1]);

            let sectionsListLocal = [] as any;
            for (let i = 0; i < result[2].length; i++) {
              let section = result[2][i];
              if (getAccessSettings(1, section.IBBDepartmentID) > 0)
                sectionsListLocal.push(section);
            }
            setSectionList(sectionsListLocal);
            setSectionListBK(sectionsListLocal);

            setCriteriaList(result[3]);
            setInputData(result[4]);

            setTotalData(result[5]);
            setTotalDataCriteria(result[6]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function formatSectionDataForScorecard() {
    let sectionListLocal = [...sectionListBK];
    if (showSummaryView) {
      for (let i = 0; i < sectionListLocal.length; i++) {
        if (!sectionListLocal[i].ManuallyAdded) {
          let IBBProgramSectionID = sectionListLocal[i].IBBProgramSectionID;
          var filtered = criteriaList.filter(
            (item: any) => item.IBBProgramSectionID == IBBProgramSectionID
          );
          if (filtered.length > 0) {
            if (
              sectionListLocal[i].AllOrNothing == 0 &&
              sectionListLocal[i].Type == 2
            ) {
              //MM:: It means its a split
              sectionListLocal.splice(i, 1);
              for (let j = 0; j < filtered.length; j++) {
                sectionListLocal.splice(i, 0, {
                  IBBProgramSectionID: filtered[j].IBBProgramCriteriaID,
                  Title: filtered[j].Title,
                  ShortTitle: filtered[j].Title,
                  Type: 2,
                  Value: filtered[j].SplitPercentage,
                  PTOrderBy: 0,
                  AllOrNothing: 0,
                  ManuallyAdded: true,
                });
              }
              i--;
            } else {
              sectionListLocal[i].CriteriaCount = filtered.length;
            }
          }
        }
      }
    } else {
      for (let i = 0; i < sectionListLocal.length; i++) {
        let IBBProgramSectionID = sectionListLocal[i].IBBProgramSectionID;
        var filtered = criteriaList.filter(
          (item: any) => item.IBBProgramSectionID == IBBProgramSectionID
        );
        if (filtered.length > 0)
          sectionListLocal[i].CriteriaCount = filtered.length;
      }
    }

    setSectionList(sectionListLocal);
  }

  function formatSectionAndCriteriaInputDataForSummaryScorecard() {
    let importerListLocal = [...importerListBK];
    let sectionListLocal = [...sectionList];

    for (let i = 0; i < importerListLocal.length; i++) {
      for (let j = 0; j < sectionListLocal.length; j++) {
        let IBBScorecardID = importerListLocal[i].IBBScorecardID;
        let IBBProgramSectionID = sectionListLocal[j].IBBProgramSectionID;
        let ManuallyAdded = sectionListLocal[j].ManuallyAdded;
                
        sectionListLocal[j]["Fails"] = 0;
        sectionListLocal[j]["Raised Exceptions"] = 0;
        sectionListLocal[j]["Approved Exceptions"] = 0;

        if (!ManuallyAdded) {
          let Title = sectionListLocal[j].Title + "-" + IBBProgramSectionID;
          importerListLocal[i][Title] = -1;
          var filtered = inputData.filter(
            (item: any) =>
              item.IBBScorecardID == IBBScorecardID &&
              item.IBBProgramSectionID == IBBProgramSectionID &&
              item.FinalResult == 0
          );
          if (filtered.length > 0) {
            importerListLocal[i][Title] = 0;
            if (
              (getAccessSettings(2, 26) > 0 &&
                globalState.AppAccessLevelData.DID > 0) ||
              globalState.AppAccessLevelData.DID == 0
            )
              importerListLocal[i][Title + "-Amount"] =
                filtered[0].FinancialValue;
          } else {
            filtered = inputData.filter(
              (item: any) =>
                item.IBBScorecardID == IBBScorecardID &&
                item.IBBProgramSectionID == IBBProgramSectionID &&
                item.FinalResult == -1
            );
            if (filtered.length > 0) {
              importerListLocal[i][Title] = 2;
              if (
                (getAccessSettings(2, 26) > 0 &&
                  globalState.AppAccessLevelData.DID > 0) ||
                globalState.AppAccessLevelData.DID == 0
              )
                importerListLocal[i][Title + "-Amount"] =
                  filtered[0].FinancialValue;
            } else {
              filtered = inputData.filter(
                (item: any) =>
                  item.IBBScorecardID == IBBScorecardID &&
                  item.IBBProgramSectionID == IBBProgramSectionID &&
                  item.FinalResult == 1
              );
              if (filtered.length > 0) {
                importerListLocal[i][Title] = 1;
                if (
                  (getAccessSettings(2, 26) > 0 &&
                    globalState.AppAccessLevelData.DID > 0) ||
                  globalState.AppAccessLevelData.DID == 0
                )
                  importerListLocal[i][Title + "-Amount"] =
                    filtered[0].FinancialValue;
              }
            }
          }

          filtered = totalData.filter(
            (item: any) => item.IBBProgramSectionID == IBBProgramSectionID
          );
          if (filtered.length > 0) {
            for (let k = 0; k < filtered.length; k++) {
              sectionListLocal[j]["Fails"] += filtered[k].Fails;
              sectionListLocal[j]["Raised Exceptions"] +=
                filtered[k].RaisedExceptions;
              sectionListLocal[j]["Approved Exceptions"] +=
                filtered[k].ApprovedExceptions;
            }
          }
        } else {
          let Title = sectionList[j].Title + "-" + IBBProgramSectionID;
          importerListLocal[i][Title] = -1;
          var filtered = inputData.filter(
            (item: any) =>
              item.IBBScorecardID == IBBScorecardID &&
              item.IBBProgramCriteriaID == IBBProgramSectionID
          );
          if (filtered.length > 0) {
            importerListLocal[i][Title] = filtered[0].FinalResult;
          }

          filtered = totalData.filter(
            (item: any) => item.IBBProgramCriteriaID == IBBProgramSectionID
          );
          if (filtered.length > 0) {
            sectionListLocal[j]["Fails"] = filtered[0].Fails;
            sectionListLocal[j]["Raised Exceptions"] =
              filtered[0].RaisedExceptions;
            sectionListLocal[j]["Approved Exceptions"] =
              filtered[0].ApprovedExceptions;
          }
        }
      }
    }

    setImporterList(importerListLocal);
  }

  function formatSectionAndCriteriaInputDataForDetailsScorecard() {
    let importerListLocal = [...importerListBK];
    let criteriaListLocal = [...criteriaList];
    for (let i = 0; i < importerListLocal.length; i++) {
      for (let j = 0; j < criteriaListLocal.length; j++) {
        let IBBScorecardID = importerListLocal[i].IBBScorecardID;
        let IBBProgramCriteriaID = criteriaListLocal[j].IBBProgramCriteriaID;
        let Title = criteriaListLocal[j].Title;
        importerListLocal[i][Title] = -1;
        
        criteriaListLocal[j]["Fails"] = 0;
        criteriaListLocal[j]["Raised Exceptions"] = 0;
        criteriaListLocal[j]["Approved Exceptions"] = 0;

        var filtered = inputData.filter(
          (item: any) =>
            item.IBBScorecardID == IBBScorecardID &&
            item.IBBProgramCriteriaID == IBBProgramCriteriaID
        );
        if (filtered.length > 0) {
          importerListLocal[i][Title] = filtered[0].FinalResult;
          if(filtered[0].FinalResult == -1)   
            importerListLocal[i][Title]=2;
        }
        filtered = totalDataCriteria.filter(
          (item: any) => item.IBBProgramCriteriaID == IBBProgramCriteriaID
        );

        if (filtered.length > 0) {
          criteriaListLocal[j]["Fails"] = filtered[0].Fails;
          criteriaListLocal[j]["Raised Exceptions"] =
            filtered[0].RaisedExceptions;
          criteriaListLocal[j]["Approved Exceptions"] =
            filtered[0].ApprovedExceptions;
        }
      }
    }

    setImporterList(importerListLocal);
    //setCriteriaList(criteriaListLocal);
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <div className="page--contents">
        <div className="page--breadcrumb">
          <a>Exceptions History</a>
        </div>
        <div className="page--data">
          <div className="flex-container">
            <div>
              <select
                className="select-md"
                value={programDashboardFilter.ProgramID}
                onChange={(e) => {
                  setProgramDashboardFilter((prevState: any) => ({
                    ...prevState,
                    ProgramID: Number(e.target.value),
                    QuarterID: 0,
                  }));
                  IBBProgramGetProgramListForScorecard(Number(e.target.value));
                }}
              >
                {programList &&
                  programList.map((Item: any, index: any) => (
                    <option value={Item.PID} key={"programoption" + Item.PID}>
                      {Item.Name}
                    </option>
                  ))}
              </select>

              <select
                style={{ marginLeft: 5 }}
                className="select-md"
                value={programDashboardFilter.QuarterID}
                onChange={(e) =>
                  setProgramDashboardFilter((prevState: any) => ({
                    ...prevState,
                    QuarterID: Number(e.target.value),
                  }))
                }
              >
                <option value={0} key={"quarteroption" + 0}>
                  YTD
                </option>
                {quarterList &&
                  quarterList.map((Item: any, index: any) => (
                    <option value={Item.PID} key={"quarteroption" + Item.PID}>
                      {Item.Name}
                    </option>
                  ))}
              </select>
            </div>

            {globalState.AppAccessLevelData.DID == 0 && (
              <select
                className="select-md"
                value={programDashboardFilter.PFIGroupIDs}
                onChange={(e) =>
                  setProgramDashboardFilter((prevState: any) => ({
                    ...prevState,
                    PFIGroupIDs: Number(e.target.value),
                  }))
                }
              >
                {groupList &&
                  groupList.map((Item: any, index: any) => (
                    <option value={Item.IBBGroupID} key={"groupoption" + index}>
                      {Item.Name}
                    </option>
                  ))}
              </select>
            )}
            <span></span>
          </div>

          {showSummaryView && (
            <div
              className="section-table tab-det tab-det-2"
              style={{ boxShadow: "none", padding: 0 }}
            >
              <table
                className="part-head trend-table fixed-table auto-table"
                id="tblData"
              >
                <thead>
                  <tr>
                    <th className="clip-box"></th>
                    <th className="clip-box">
                      <div className="ib-legends">
                        <div className="ib-l-box">
                          <span className="ib-box-spn ib-green"></span>
                          <span>Passed</span>
                        </div>
                        <div className="ib-l-box">
                          <span className="ib-box-spn ib-red"></span>
                          <span>Failed</span>
                        </div>

                        <div className="ib-l-box">
                          <span className="ib-box-spn ib-amber"></span>
                          <span>In Progress</span>
                        </div>
                      </div>
                    </th>
                    <th className="clip-box"></th>
                    {sectionList &&
                      sectionList.length > 0 &&
                      sectionList[0].Type == 1 &&
                      sectionList[0].CriteriaCount > 0 && <th>GATEWAY</th>}
                    <th
                      colSpan={
                        sectionList.length -
                        (sectionList &&
                        sectionList.length > 0 &&
                        sectionList[0].Type == 1 &&
                        sectionList[0].CriteriaCount > 0
                          ? 1
                          : 0)
                      }
                    >
                      CRITERIA
                    </th>
                  </tr>
                  <tr>
                    <th className="clip-box"></th>
                    <th className="clip-box"></th>
                    <th className="clip-box">
                      <a
                        className="show-summary"
                        onClick={(e) => {
                          setShowSummaryView(false);
                        }}
                      >
                        Details
                      </a>
                    </th>
                    {sectionList &&
                      sectionList.map((item: any, index: any) => (
                        <React.Fragment key={"sectionheading" + index}>
                          <th>
                            {item.ShortTitle}&nbsp;
                            {item.Type == 2 && (
                              <>
                                {item.Value.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                })}
                                %
                              </>
                            )}
                          </th>
                        </React.Fragment>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {totalDataRows &&
                    totalDataRows.map((itemTotal: any, indexTotal: any) => (
                      <React.Fragment key={"totallist" + indexTotal}>
                        <tr>
                          <td colSpan={2} className="z-in"></td>
                          <td>{itemTotal.Name}</td>
                          {sectionList &&
                            sectionList.map(
                              (sectionItem: any, sectionIndex: any) => (
                                <React.Fragment
                                  key={
                                    "sectionscorecardtotal" +
                                    0 +
                                    "" +
                                    sectionIndex
                                  }
                                >
                                  <td className="text-right">
                                    {sectionItem[itemTotal.Name]}
                                  </td>
                                </React.Fragment>
                              )
                            )}
                        </tr>
                      </React.Fragment>
                    ))}

                  {dealerList &&
                    dealerList.map((itemimporter: any, indeximporter: any) => (
                      <React.Fragment key={"dealerlist" + indeximporter}>
                        <tr>
                          <td
                            rowSpan={
                              programDashboardFilter.QuarterID == 0 ? 5 : 2
                            }
                          >
                            {itemimporter.MarketName}
                          </td>
                          <td
                            rowSpan={
                              programDashboardFilter.QuarterID == 0 ? 5 : 2
                            }
                            className="wid-dealer"
                          >
                            <div className="flex-td-in">
                              {itemimporter.DealerName}
                            </div>
                          </td>
                        </tr>

                        {importerList &&
                          importerList.map((item: any, index: any) => (
                            <React.Fragment key={"importerscorecard" + index}>
                              {itemimporter.PFIDealerID == item.PFIDealerID && (
                                <tr>
                                  <td>Q{item.NumericQuarter}</td>

                                  {sectionList &&
                                    sectionList.map(
                                      (sectionItem: any, sectionIndex: any) => (
                                        <React.Fragment
                                          key={
                                            "sectionscorecarddata" +
                                            index +
                                            "" +
                                            sectionIndex
                                          }
                                        >
                                          <td
                                            className={`${
                                              item[
                                                sectionItem.Title +
                                                  "-" +
                                                  sectionItem.IBBProgramSectionID
                                              ] == 1
                                                ? "GreenClass"
                                                : item[
                                                    sectionItem.Title +
                                                      "-" +
                                                      sectionItem.IBBProgramSectionID
                                                  ] == 0
                                                ? "RedClass"
                                                : item[
                                                    sectionItem.Title +
                                                      "-" +
                                                      sectionItem.IBBProgramSectionID
                                                  ] == 2
                                                ? "OrangeClass"
                                                : ""
                                            }`}
                                          >
                                            {item[
                                              sectionItem.Title +
                                                "-" +
                                                sectionItem.IBBProgramSectionID +
                                                "-Amount"
                                            ] != null && (
                                              <span className="text-right">
                                                $
                                                {item[
                                                  sectionItem.Title +
                                                    "-" +
                                                    sectionItem.IBBProgramSectionID +
                                                    "-Amount"
                                                ]?.toLocaleString(undefined, {
                                                  minimumFractionDigits: 0,
                                                  maximumFractionDigits: 0,
                                                })}
                                              </span>
                                            )}
                                          </td>
                                        </React.Fragment>
                                      )
                                    )}
                                </tr>
                              )}
                            </React.Fragment>
                          ))}
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </div>
          )}

          {!showSummaryView && (
            <div
              className="section-table tab-det tab-det-2"
              style={{ boxShadow: "none", padding: 0 }}
            >
              <table
                className="part-head trend-table fixed-table auto-table"
                id="tblData"
              >
                <thead>
                  <tr>
                    <th className="clip-box"></th>
                    <th className="clip-box">
                      <div className="ib-legends">
                        <div className="ib-l-box">
                          <span className="ib-box-spn ib-green"></span>
                          <span>Passed</span>
                        </div>
                        <div className="ib-l-box">
                          <span className="ib-box-spn ib-red"></span>
                          <span>Failed</span>
                        </div>

                        <div className="ib-l-box">
                          <span className="ib-box-spn ib-amber"></span>
                          <span>In Progress</span>
                        </div>
                      </div>
                    </th>
                    <th className="clip-box"></th>
                    {sectionList &&
                      sectionList.length > 0 &&
                      sectionList[0].Type == 1 &&
                      sectionList[0].CriteriaCount > 0 && (
                        <th colSpan={sectionList[0].CriteriaCount}>GATEWAY</th>
                      )}
                    <th
                      colSpan={
                        criteriaList.length -
                        (sectionList &&
                        sectionList.length > 0 &&
                        sectionList[0].Type == 1 &&
                        sectionList[0].CriteriaCount > 0
                          ? sectionList[0].CriteriaCount
                          : 0)
                      }
                    >
                      CRITERIA
                    </th>
                  </tr>
                  <tr>
                    <th className="clip-box"></th>
                    <th className="clip-box"></th>
                    <th className="clip-box">
                      {" "}
                      <a
                        className="show-summary"
                        onClick={(e) => {
                          setShowSummaryView(true);
                        }}
                      >
                        Summary
                      </a>
                    </th>

                    {sectionList &&
                      sectionList.map((item: any, index: any) => (
                        <React.Fragment key={"sectionheading" + index}>
                          {item.CriteriaCount > 0 && (
                            <th colSpan={item.CriteriaCount}>
                              {item.ShortTitle}&nbsp;
                              {item.Type == 2 && (
                                <>
                                  {item.Value.toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                  })}
                                  %
                                </>
                              )}
                            </th>
                          )}
                        </React.Fragment>
                      ))}
                  </tr>
                  <tr>
                    <th className="clip-box"></th>
                    <th className="clip-box"></th>
                    <th className="clip-box"></th>
                    {criteriaList &&
                      criteriaList.map((item: any, index: any) => (
                        <React.Fragment key={"criteriaheading" + index}>
                          <th>{item.Title}</th>
                        </React.Fragment>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {totalDataRows &&
                    totalDataRows.map((itemTotal: any, indexTotal: any) => (
                      <React.Fragment key={"totallist" + indexTotal}>
                        <tr>
                          <td colSpan={2} className="z-in"></td>
                          <td>{itemTotal.Name}</td>
                          {criteriaList &&
                            criteriaList.map(
                              (criteriaItem: any, criteriaIndex: any) => (
                                <React.Fragment
                                  key={
                                    "criteriascorecardtotal" +
                                    0 +
                                    "" +
                                    criteriaIndex
                                  }
                                >
                                  <td className="text-right">
                                    {criteriaItem[itemTotal.Name]}
                                  </td>
                                </React.Fragment>
                              )
                            )}
                        </tr>
                      </React.Fragment>
                    ))}

                  {dealerList &&
                    dealerList.map((itemimporter: any, indeximporter: any) => (
                      <React.Fragment key={"dealerlist" + indeximporter}>
                        <tr>
                          <td
                            rowSpan={
                              programDashboardFilter.QuarterID == 0 ? 5 : 2
                            }
                            className="z-in"
                          >
                            {itemimporter.MarketName}
                          </td>
                          <td
                            rowSpan={
                              programDashboardFilter.QuarterID == 0 ? 5 : 2
                            }
                            className="wid-dealer z-in"
                          >
                            <div className="flex-td-in">
                              {itemimporter.DealerName}
                            </div>
                          </td>
                        </tr>

                        {importerList &&
                          importerList.map((item: any, index: any) => (
                            <React.Fragment key={"importerscorecard" + index}>
                              {itemimporter.PFIDealerID == item.PFIDealerID && (
                                <tr>
                                  <td>Q{item.NumericQuarter}</td>

                                  {criteriaList &&
                                    criteriaList.map(
                                      (
                                        criteriaItem: any,
                                        criteriaIndex: any
                                      ) => (
                                        <React.Fragment
                                          key={
                                            "criteriascorecarddata" +
                                            index +
                                            "" +
                                            criteriaIndex
                                          }
                                        >
                                          <td
                                            className={`${
                                              item[criteriaItem.Title] == 1
                                                ? "GreenClass"
                                                : item[criteriaItem.Title] == 0
                                                ? "RedClass"
                                                : item[criteriaItem.Title] == 2
                                                ? "OrangeClass"
                                                : ""
                                            }`}
                                          ></td>
                                        </React.Fragment>
                                      )
                                    )}
                                </tr>
                              )}
                            </React.Fragment>
                          ))}
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
